import { render, staticRenderFns } from "./TwitterTimeline.vue?vue&type=template&id=8a9e983c"
import script from "./TwitterTimeline.vue?vue&type=script&lang=js"
export * from "./TwitterTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports